export default {
  multimedia: {
    upload: {
      dragDrop: "Drag and drop files here",
      dragDropCompact: "Click or drag files",
      dropFiles: "Drop files to upload",
      orClickToBrowse: "or click to browse files",
      browse: "Browse Files",
      progress: "Upload Progress",
      completed: "Completed",
      clearCompleted: "Clear Completed",
      preview: "File Preview",
      sizeLimits: "Max sizes: Images {image}, Audio {audio}, Video {video}",
      tooManyFiles: "Too many files selected. Maximum {max} files allowed.",
      cancelUpload: "Cancel upload",
      removeUpload: "Remove upload",
      removeFile: "Remove file",
    },
    error: {
      invalidType: "File type not supported",
      fileTooLarge:
        "File too large. Maximum size: {maxSize}, actual size: {actualSize}",
      dimensionsTooLarge:
        "Image dimensions too large. Maximum: {maxWidth}x{maxHeight}, actual: {actualWidth}x{actualHeight}",
      durationTooLong:
        "Media duration too long. Maximum: {maxDuration}, actual: {actualDuration}",
      invalidImage: "Invalid image file",
      invalidMedia: "Invalid media file",
    },
    types: {
      images: "images",
      audio: "audio",
      videos: "videos",
    },
    gallery: {
      title: "Media Gallery",
      preview: "Media Preview",
      noMedia: "No media files",
      loading: "Loading media...",
      loadingError: "Failed to load media",
      progressiveLoading: "Loading progressively...",
      clickToLoad: "Click to load video",
      fullscreen: "View fullscreen",
      download: "Download",
      delete: "Delete",
      previous: "Previous",
      next: "Next",
      close: "Close",
      play: "Play",
      pause: "Pause",
      mute: "Mute",
      unmute: "Unmute",
      volume: "Volume",
      duration: "Duration",
      currentTime: "Current time",
      items: "items",
    },
    management: {
      title: "Manage Attachments",
      reorder: "Reorder attachments",
      replace: "Replace file",
      editMetadata: "Edit metadata",
      order: "Order",
      deleteConfirm: "Are you sure you want to delete this attachment?",
      deleteMultipleConfirm:
        "Are you sure you want to delete {count} attachments?",
      deleteSuccess: "Attachment deleted successfully",
      deleteError: "Failed to delete attachment",
      updateSuccess: "Attachment updated successfully",
      updateError: "Failed to update attachment",
    },
    maintenance: {
      title: "Storage Maintenance",
      loading: "Loading maintenance statistics...",
      loadError: "Failed to load maintenance statistics",
      totalStorage: "Total Storage Used",
      orphanedStorage: "Orphaned Files",
      spaceSaved: "Space Saved",
      lastCleanup: "Last Cleanup",
      files: "files",
      orphanedFiles: "orphaned files",
      compressedFiles: "compressed files",
      runCleanup: "Run Cleanup",
      running: "Running maintenance...",
      triggered: "Maintenance job started successfully",
      triggerError: "Failed to start maintenance job",
      daysAgo: "{days} days ago",
      hoursAgo: "{hours} hours ago",
      recently: "Recently",
    },
  },
  loading: "Loading...",
  close: "Close",
  cron: {
    syntaxHelp: "Show cron syntax help",
    monthValues: "Show month values",
    weekdayValues: "Show weekday values",
    modeFriendly: "Friendly",
    modeSimple: "Simple",
    modeAdvanced: "Advanced",
    frequency: "Frequency",
    freq: {
      minutes: "Every N minutes",
      hourly: "Hourly",
      daily: "Daily",
      weekly: "Weekly",
      monthly: "Monthly",
    },
    everyNMinutes: "Every N minutes",
    atMinute: "At minute (0–59)",
    atTime: "At time",
    onDays: "On these days",
    dayOfMonth: "Day of month (1–31)",
    customPatternHint:
      "This is a custom cron pattern that can't be shown with the Friendly editor. Use Simple or Advanced to edit it, or reset to a friendly default.",
    resetFriendly: "Reset to a friendly default",
  },
  pagination: {
    previous: "Previous",
    next: "Next",
    page: "Page {current}",
    pageOf: "Page {current} of {total}",
  },
  uploader: {
    cropImage: "Crop image",
    uploading: "Uploading…",
    dropImageHere: "Drop image here",
    clickToReplaceImage: "Click to replace image",
    clickToUploadImage: "Click to upload image",
    orDragAndDrop: "or drag and drop",
    uploadFailed: "Upload failed",
    dropFileHere: "Drop file here",
    dropAnotherFile: "Drop another file here",
    selectOrDropFile: "Select or drop file here",
    maxSize: "Max {size}",
    allFiles: "All files",
    imagesSupported: "Images supported",
    audioSupported: "Audio supported",
    videoSupported: "Video supported",
    documentsSupported: "Documents supported",
    cropImageTitle: "Crop Image",
    cancel: "Cancel",
    upload: "Upload",
    replace: "Replace",
    remove: "Remove",
    fileTooLarge: "File too large. Max {max}.",
    uploadSuccess: "File uploaded successfully.",
    uploadError: "Upload failed",
    uploadErrorDesc: "Unknown error",
    uploadErrorServer: "Upload error",
  },
};
